import api from "./index";

/**
 * Busca produtos de um evento específico
 * @param {string} eventEditionCode - Código da edição do evento
 * @param {string} token - Token de autenticação
 * @returns {Promise} Promise com a resposta da API
 */
export const getProductsByEventService = async (eventEditionCode, token) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.patch(
    `/admin/ecommerce/chleba/product-event`,
    { eventEditionCode },
    configHeaders,
  );
};

/**
 * Salva produtos selecionados para a homepage
 * @param {number} eventId - ID do evento
 * @param {Array} products - Array de produtos com englishName, productLocalName e icon
 * @param {string} token - Token de autenticação
 * @returns {Promise} Promise com a resposta da API
 */
export const saveHomepageProductsService = async (eventId, products, token) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  const body = {
    eventId,
    products,
  };

  return await api.post(`/homepage-products`, body, configHeaders);
};

/**
 * Busca produtos cadastrados na homepage de um evento
 * @param {number} eventId - ID do evento
 * @param {string} token - Token de autenticação
 * @returns {Promise} Promise com a resposta da API
 */
export const getHomepageProductsByEventService = async (eventId, token) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get(`/homepage-products/event/${eventId}`, configHeaders);
};

/**
 * Atualiza produtos da homepage
 * @param {number} eventId - ID do evento
 * @param {Array} products - Array de produtos com englishName, productLocalName e icon
 * @param {string} token - Token de autenticação
 * @returns {Promise} Promise com a resposta da API
 */
export const updateHomepageProductsService = async (
  eventId,
  products,
  token,
) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  const body = {
    eventId,
    products,
  };

  return await api.put(`/homepage-products`, body, configHeaders);
};

/**
 * Deleta um produto da homepage
 * @param {number} productId - ID do produto da homepage
 * @param {string} token - Token de autenticação
 * @returns {Promise} Promise com a resposta da API
 */
export const deleteHomepageProductService = async (productId, token) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.delete(
    `/homepage-products/product/${productId}`,
    configHeaders,
  );
};

/**
 * Busca produtos e categorias de um evento pelo ID
 * @param {number} eventId - ID do evento
 * @param {string} token - Token de autenticação
 * @returns {Promise} Promise com a resposta da API contendo produtos e categorias
 */
export const getProductsAndCategoriesByEventIdService = async (
  eventId,
  token,
) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get(
    `/admin/ecommerce/products/event/${eventId}`,
    configHeaders,
  );
};
